module.exports = __webpack_public_path__ + "static/media/loading.2d243ac6.gif";